import {Endpoints} from "../Endpoints";
import Backend from "../../Backend";

export default class CardType
{
	constructor(token)
	{
		this.backend = new Backend(token);
	}

	all(callback)
	{
		this.backend.callBackend(`${Endpoints.cardType.private}/all`, callback);
	}

	errorShow(callback){
		this.backend.callBackend(`${Endpoints.cardType.error}/check-server-response`, callback);
	}

	allByBrand(id, callback)
	{
		this.backend.callBackend(`${Endpoints.cardType.private}/brand/${id}`, callback);
	}

	allBySupplierBrand(id, purchaserId, callback)
	{
		this.backend.callBackend(`${Endpoints.cardType.private}/supplier/brand/${id}/${purchaserId}`, callback);
	}

	cardType(id, callback)
	{
		this.backend.callBackend(`${Endpoints.cardType.private}/${id}`, callback);
	}

	giftCardDetails(brandId,id,callback){
		this.backend.callBackend(`${Endpoints.supplier.details}/${brandId}/supplier/${id}`,callback)
	}

	add(cardTypeInfo, callback)
	{
		const data = new FormData();
		data.append("request", JSON.stringify(cardTypeInfo));
		

	this.backend.callBackend(`${Endpoints.cardType.private}/create/new`, callback, "POST", data, false);
	}
    brandCatalog(id,callback){
		this.backend.callBackend(`${Endpoints.brand.private}/catalog/${id}`, callback);
     }
	update(data, callback)
	{
		this.backend.callBackend(`${Endpoints.cardType.private}`, callback, "PUT", data);
	}

	remove(id, callback)
	{
		this.backend.callBackend(`${Endpoints.cardType.private}/${id}`, callback, "DELETE");
	}

	updateImage(uuid, image, callback)
	{
		const data = new FormData();
		data.append("image", image);
		this.backend.callBackend(`${Endpoints.cardType.private}/image/${uuid}`, callback, "PUT", data, false);
	}

	
	image(uuid, forceReload = false, suffix = null)
	{
		return `${this.backend.url}${Endpoints.cardType.public}/image/${encodeURIComponent(uuid)}${forceReload ? "?no-cache=" + (suffix ?? Date.now()) : ''}`;
	}
	uploadCardType(data, callback) {
		this.backend.callBackend(`${Endpoints.cardType.private}/upload`, callback, 'POST', data , false)
	  }
	  
	  downloadCardType(callback) {
		this.backend.callBackend(`${Endpoints.cardType.private}/download`, callback, "GET")
	  }
}